import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../context/AuthContext';
import { canAccessFeature } from '../utils/planAccess';
import UpgradeCta from './UpgradeCta';
import LoadingSpinner from './LoadingSpinner';
import './PlanGatedRoute.css';

const PLAN_FEATURE_I18N_KEYS = {
  exportData: 'planFeatureExportData',
  taskPresets: 'planFeatureTaskPresets',
  checklistPresets: 'planFeatureChecklistPresets',
  taskImageUploads: 'planFeatureTaskImageUploads',
  handouts: 'planFeatureHandouts',
  advancedAnalytics: 'planFeatureAdvancedAnalytics',
  customIntegrations: 'planFeatureCustomIntegrations',
  taskWorkGroups: 'planFeatureTaskWorkGroups'
};

const PlanGatedRoute = ({ capability, children }) => {
  const { t } = useTranslation('common');
  const { user, loading } = useContext(AuthContext);
  const featureKey = PLAN_FEATURE_I18N_KEYS[capability];
  const featureName = featureKey ? t(featureKey) : t('planGateDefaultFeature');

  if (loading) {
    return <LoadingSpinner className="plan-gate-loading" />;
  }

  if (canAccessFeature(user, capability)) {
    return children;
  }

  return (
    <div className="plan-gate-page">
      <div className="plan-gate-card">
        <span className="material-symbols-outlined plan-gate-icon" aria-hidden="true">
          lock
        </span>
        <h2 className="plan-gate-title">{featureName}</h2>
        <p className="plan-gate-message">
          {t('planGateNotIncluded', { feature: featureName })}
        </p>
        <UpgradeCta className="plan-gate-cta" capability={capability} />
      </div>
    </div>
  );
};

export default PlanGatedRoute;
